import { render } from "./deposit-withdraw-block.vue?vue&type=template&id=241f0c21&scoped=true"
import script from "./deposit-withdraw-block.vue?vue&type=script&lang=js"
export * from "./deposit-withdraw-block.vue?vue&type=script&lang=js"

import "./deposit-withdraw-block.vue?vue&type=style&index=0&id=241f0c21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241f0c21"]])

export default __exports__